import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { MobileOperator } from '@/types';
import { useDeleteMobileOperatorMutation } from '@/services';

export interface DeleteMobileOperatorProps extends DialogProps {
  mobileOperator: MobileOperator;
  onClose(): void;
}

const DeleteMobileOperator: React.FC<DeleteMobileOperatorProps> = ({ mobileOperator, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteMobileOperator, deleteMobileOperatorResponse] = useDeleteMobileOperatorMutation();

  async function handleDeleteMobileOperator() {
    try {
      await deleteMobileOperator(mobileOperator).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{mobileOperator?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{mobileOperator?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="secondary"
          variant="outlined"
          disabled={deleteMobileOperatorResponse.isLoading}
          onClick={onClose}
        >
          Закрыть
        </Button>

        <Button
          variant="contained"
          disabled={deleteMobileOperatorResponse.isLoading}
          onClick={handleDeleteMobileOperator}
        >
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteMobileOperator;
